import PrinciplePalette from "../../../../src/components/docs/examples/Color/PrinciplePalette";
import ThemeColors from "../../../../src/components/docs/examples/Color/ThemeColors";
import PrefersColorScheme from "../../../../src/components/docs/examples/Color/PrefersColorScheme";
import LinkColors from "../../../../src/components/docs/examples/Color/LinkColors";
import FeedbackColors from "../../../../src/components/docs/examples/Color/FeedbackColors";
import InfinitelyNestable from "../../../../src/components/docs/examples/Color/InfinitelyNestable";
import * as React from 'react';
export default {
  PrinciplePalette,
  ThemeColors,
  PrefersColorScheme,
  LinkColors,
  FeedbackColors,
  InfinitelyNestable,
  React
};